var map = {
	"./check.svg": "bf45",
	"./close.svg": "d64e",
	"./file.svg": "113f",
	"./fold.svg": "aca8",
	"./gou.svg": "0741",
	"./homework.svg": "f0fa",
	"./post.svg": "d7ae",
	"./record.svg": "5f18"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79da";